import {Button, Modal, Result, Spin} from "../../../../__snowpack__/pkg/antd.js";
import React, {useState} from "../../../../__snowpack__/pkg/react.js";
import ChannelIcon from "../../../components/ChannelIcon.js";
import {CHANNEL_ID_ENUM, CHANNEL_NAME_ENUM} from "../../../enums/channel.js";
import {Space, Typography} from "../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {useRequest} from "../../../../__snowpack__/pkg/ahooks.js";
import {sumBy} from "../../../../__snowpack__/pkg/lodash.js";
import {request} from "../../../utils/request/index.js";
import {eventLogger} from "../../../lib/eventLogger.js";
import {useUpdateRoute} from "../../../lib/useIframe.js";
import QueryString from "../../../../__snowpack__/pkg/qs.js";
export default function CloneProductsResultModal(props) {
  const {taskId, onClose, copyType, sourceChannelId, countryCode = "ID"} = props;
  const {formatMessage} = useIntl();
  const {updateRoute} = useUpdateRoute();
  const [failedReasonList, setFailedReasonList] = useState([]);
  const {
    data: cloneResult,
    loading: queryCloneResultLoading,
    cancel: cancelQueryCloneResult
  } = useRequest(() => request.get(`/saas/product/batch_clone_result/${taskId}`), {
    pollingInterval: 100,
    onSuccess: (data) => {
      if (data?.operationStatus !== "IN_PROCESS") {
        cancelQueryCloneResult();
        const {processInfos = []} = data || {};
        if (processInfos?.length) {
          const totalSuccessCount = sumBy(processInfos, "successCount") || 0;
          const targetInfo = processInfos[0] || {};
          if (targetInfo?.failedProductInfo && targetInfo?.failedProductInfo.length > 0) {
            setFailedReasonList(targetInfo?.failedProductInfo);
          }
          eventLogger.push({
            action: "ClickCopyAsDraft",
            location: "CopyListingPopup",
            actionExtra: {
              type: copyType,
              cloneInfo: {
                source: sourceChannelId,
                target: targetInfo?.channelId,
                cloneCnt: totalSuccessCount
              },
              Result: totalSuccessCount > 0 ? "Succeed" : "Failed"
            }
          });
        }
      }
    },
    onError: () => {
      cancelQueryCloneResult();
    },
    ready: !!taskId
  });
  const channelId = cloneResult?.processInfos?.[0]?.channelId;
  const goToBatchEditPage = () => {
    let productIds = [];
    let productList = [];
    let shopIds = [];
    cloneResult?.processInfos?.forEach((info) => {
      shopIds.push(info.shopId);
      info.successProductIds.forEach((productId) => {
        productIds.push(productId);
        productList.push({
          id: productId,
          channelId: info.channelId,
          shopId: info.shopId
        });
      });
    });
    switch (channelId) {
      case CHANNEL_ID_ENUM.SHOPEE:
        localStorage.setItem("shopeeSelectedProductList", JSON.stringify(productList));
        updateRoute(`product-shopee-mass-edit-category-attribute?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      case CHANNEL_ID_ENUM.TIKTOK:
        localStorage.setItem("tiktokSelectedProductList", JSON.stringify(productList));
        updateRoute(`product-tiktok-mass-edit-category-attribute?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      case CHANNEL_ID_ENUM.WOO_COMMERCE:
        localStorage.setItem("wooProductList", JSON.stringify(productList));
        updateRoute(`product-woo-commerce/mass-edit-category?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      case CHANNEL_ID_ENUM.BLIBLI:
        localStorage.setItem("blibliCategoryList", JSON.stringify(productList));
        updateRoute(`product-blibli/mass-category?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      case CHANNEL_ID_ENUM.LAZADA:
        sessionStorage.setItem("lazadaMassEditProductIds", JSON.stringify(productIds));
        updateRoute(`product-lazada-mass-category?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      case CHANNEL_ID_ENUM.TOKOPEDIA:
        sessionStorage.setItem("product-tokopedia-mass-edit-ids", JSON.stringify(productIds));
        updateRoute(`product-tokopedia-mass-edit-category-attribute?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      case CHANNEL_ID_ENUM.BUKALAPAK:
        sessionStorage.setItem("product-bukalapak-mass-edit-ids", JSON.stringify(productIds));
        updateRoute(`product-bukalapak-mass-edit-category-attribute?${QueryString.stringify({
          status: "DRAFT",
          countryCode
        })}`);
        break;
      default:
        const catcheKey = Math.random().toString(36).slice(-8);
        const massedtiproducts = JSON.stringify({channelId, productIds});
        const categoryList = JSON.stringify(productList);
        localStorage.setItem("massedtiproducts" + catcheKey, massedtiproducts);
        localStorage.setItem("categoryList" + catcheKey, categoryList);
        const queries = {
          fromurl: location.pathname + location.search,
          catcheKey,
          status: "DRAFT",
          countryCode,
          channelId,
          shopIds: QueryString.stringify(shopIds)
        };
        const channelName = CHANNEL_NAME_ENUM[channelId] ?? channelId;
        updateRoute(`product/${channelName}/mass-category?${QueryString.stringify({
          ...queries
        })}`);
        break;
    }
  };
  return /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "result"}),
    visible: !!taskId,
    width: 560,
    onCancel: () => {
      onClose();
    },
    footer: null
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: queryCloneResultLoading || cloneResult?.operationStatus === "IN_PROCESS"
  }, /* @__PURE__ */ React.createElement("div", {
    style: {minHeight: 200}
  }, cloneResult && cloneResult?.operationStatus !== "IN_PROCESS" && /* @__PURE__ */ React.createElement(Result, {
    status: cloneResult?.operationStatus === "FAILED" ? "error" : "success",
    title: formatMessage({id: "copyCompete"}),
    style: {padding: 0},
    extra: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Space, {
      direction: "vertical",
      style: {width: "100%", marginBottom: 24, maxHeight: 200, overflow: "auto"}
    }, cloneResult?.processInfos?.map((shopResult) => /* @__PURE__ */ React.createElement(Space, {
      direction: "vertical",
      style: {
        background: "#f0f2f5",
        width: "100%",
        padding: 8,
        borderRadius: 4
      }
    }, /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(ChannelIcon, {
      channelId: sourceChannelId
    }), shopResult.shopName), /* @__PURE__ */ React.createElement(Space, {
      size: "large"
    }, /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(Typography.Text, {
      type: "success"
    }, shopResult.successCount), formatMessage({id: "copyAsDraftTip"})), /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(Typography.Text, {
      type: "danger"
    }, shopResult.failedCount), formatMessage({id: "copyFailedResult"})))))), failedReasonList.length > 0 && /* @__PURE__ */ React.createElement(Space, {
      direction: "vertical",
      style: {
        width: "100%",
        marginBottom: 24,
        maxHeight: 200,
        overflow: "auto",
        background: "#f0f2f5",
        padding: 8,
        borderRadius: 4
      }
    }, /* @__PURE__ */ React.createElement("div", null, "\u5931\u8D25\u539F\u56E0:"), failedReasonList.map((item) => {
      return /* @__PURE__ */ React.createElement("div", null, item?.productName, ":", item?.failedRason);
    })), /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(Button, {
      onClick: () => {
        onClose();
      }
    }, formatMessage({id: "close"})), /* @__PURE__ */ React.createElement(Button, {
      type: "primary",
      onClick: () => {
        const productListPathMap = {
          [CHANNEL_ID_ENUM.SHOPEE]: "product-shopee",
          [CHANNEL_ID_ENUM.TIKTOK]: "product-tiktok",
          [CHANNEL_ID_ENUM.TOKOPEDIA]: "product-tokopedia",
          [CHANNEL_ID_ENUM.BUKALAPAK]: "product-bukalapak",
          [CHANNEL_ID_ENUM.JD_TH]: "product-jd-th",
          [CHANNEL_ID_ENUM.ZALORA]: "product-zalora",
          [CHANNEL_ID_ENUM.SHOPIFY]: "product-shopify",
          [CHANNEL_ID_ENUM.WOO_COMMERCE]: "product-woo-commerce",
          [CHANNEL_ID_ENUM.BLIBLI]: "product-blibli",
          [CHANNEL_ID_ENUM.LAZADA]: "product-lazada"
        };
        let path;
        if (productListPathMap[channelId]) {
          path = productListPathMap[channelId] + "?status=DRAFT";
        } else {
          path = `product/${CHANNEL_NAME_ENUM[channelId]}?channelId=${channelId}&status=DRAFT`;
        }
        updateRoute(path);
        onClose();
      }
    }, formatMessage({id: "checkNow"})), [
      "BUKALAPAK_ID",
      "SHOPEE_ID",
      "WOO_COMMERCE_ID",
      "TOKOPEDIA_ID",
      "LAZADA_ID",
      "TIKTOK_ID"
    ].includes(channelId) && /* @__PURE__ */ React.createElement(Button, {
      type: "primary",
      onClick: () => {
        goToBatchEditPage();
      }
    }, formatMessage({id: "editProduct"}))))
  }))));
}
